import { useMemo } from "react";
import { cn } from "../../../../../../util/cn";
import ExclamationCloudSVG from "../../../../../custom-ui/icons/ExclamationCloudSVG";
import moment from "moment";

type TCancelMonthlyPlanModalProps = {
  onCancel: () => void;
  onProceed: () => void;
  employer: any;
  isCancelPlanDisabled:boolean
};

const CancelMonthlyPlanModal = ({
  onCancel,
  onProceed,
  employer,
  isCancelPlanDisabled
}: TCancelMonthlyPlanModalProps) => {


  const formatTimestamp = (timestamp: any, plan: string) => {
    if (!timestamp || !timestamp.seconds) return "";

    // Convert Firebase timestamp to JavaScript Date
    let date = new Date(timestamp.seconds * 1000);

    // Add 30 days if plan is "monthly"
    if (plan === "monthly") {
      date.setDate(date.getDate() + 30);
    }
    if (plan === "annual" || plan === "annual12" || plan === "annual24") {
      date.setDate(date.getDate() + 365);
    }



    // Format the date in "DD MMM YYYY"
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  <span className="absolute left-0 top-0">•</span>




  return (
    <div className={cn("flex flex-col items-center ", {})}>
      <div className="flex flex-col gap-[20px] items-center">
        <ExclamationCloudSVG />

        <p className="w-[330px] font-[Gilroy-Bold] font-[400] text-[24px] leading-[29.71px] text-[#15415E] text-center">
          Confirm Cancellation
        </p>

        <ul className="space-y-2 list-none text-[#616161] font-[Gilroy-Medium] font-[400] text-[16px] leading-[23px]">
          <li className="relative pl-5">
            <span className="absolute left-0 top-0">•</span>
            You are about to cancel your subscription
          </li>
          <li className="relative pl-5">
            <span className="absolute left-0 top-0">•</span>
            Your current plan benefits will remain active until{" "}
            {formatTimestamp(
              employer?.lastMonthlyCreditAdded,
              employer?.currentPlan,
            )} and no credits will be removed
          </li>
          <li className="relative pl-5">
            <span className="absolute left-0 top-0">•</span>
            After {formatTimestamp(
              employer?.lastMonthlyCreditAdded,
              employer?.currentPlan,
            )}, you will not receive additional credits, &
            your subscription will not renew
          </li>
          <li className="relative pl-5">
            <span className="absolute left-0 top-0">•</span>
            Please note: this action cannot be undone
          </li>
         
        </ul>
        <p className="w-full text-center font-semibold  text-instant-teams-blue-Main"> Do you want to continue?</p>
      </div>

      <div className="flex flex-row justify-center items-center gap-[15px] mt-[30px]">
        <button
          className="flex justify-center items-center h-[60px] w-[230px] rounded-[70px] border-[1px] border-[#15415E] py-[25px] hover:border-[#1d5174] hover:bg-slate-200 text-[#15415E] text-[16px] leading-[24.76px] font-[400] font-[Gilroy-Bold]"
          onClick={onCancel}
        >
         Keep My Subscription
        </button>
        <button
          className={cn(
            "flex justify-center items-center h-[60px] w-[230px] py-[25px] rounded-[70px] text-[16px] leading-[24.76px] font-[400] font-[Gilroy-Bold]",
            isCancelPlanDisabled
              ? "bg-gray-400 text-[#FFFFFF] cursor-not-allowed"
              : "bg-[#ED3535] text-[#FFFFFF]"
          )}
          onClick={onProceed}
        >
         Confirm Cancellation
        </button>
      </div>
    </div>
  );
};

export default CancelMonthlyPlanModal;
